import { Component, Input, OnChanges, OnInit, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { AbstractControl, UntypedFormControl } from '@angular/forms';
import { Validator } from 'projects/core/src/lib/helpers/validator';
import { TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'app-form-control',
  templateUrl: './form-control.component.html',
  styleUrls: ['./form-control.component.scss']
})
export class FormControlComponent implements OnInit, OnChanges {

  controlConfig: any = {
    rows: 5,
    autoResize: false
  };

  @ViewChild('field') field: ElementRef;

  @Input() control: UntypedFormControl = null;
  @Input() cid: string = null;
  @Input() label: string = null;
  @Input() type: string = null;
  @Input() filter = false;
  @Input() filterBy = '';
  @Input() showClear = false;
  @Input() showAllSelected = false;
  @Input() basevalue: any = null;
  @Input() optionLabel: any = null;
  @Input() optionGroupLabel: any = null;
  @Input() optionGroupChildren: any = null;
  @Input() group: boolean = false;
  @Input() dataKey: any = null;
  @Input() edit = true;
  @Input() options: Array<any> = [];
  @Input() config: any;
  @Input() min: number;
  @Input() max: number;
  @Input() step: number;
  @Input() readonlyInput: boolean;
  @Input() minDate: any;
  @Input() maxDate: any;
  @Input() dateRangeMode = false;
  @Input() showTime = true;
  @Input() showLabel = true;
  @Input() placeholder = '';
  @Input() showPlaceholder = true;
  @Input() inline = false;
  @Input() noMargin = false;
  @Input() info = null;
  @Input() editable = false;

  @Output() changed = new EventEmitter<any>();

  get firstDayOfWeek(): number {
    return (this.transloco.getActiveLang() === 'de') ? 1 : 0;
  }

  constructor(
    private transloco: TranslocoService
  ) { }

  ngOnInit(): void {
  }

  ngOnChanges(): void {
    if (Validator.isObject(this.config)) {
      Object.keys(this.config).forEach((key: string) => {
        this.controlConfig[key] = this.config[key];
      });
    }
  }

  isRequired(): boolean {
    if (this.control.validator) {
        const validator = this.control.validator({} as AbstractControl);
        if (validator && validator.required) {
            return true;
        }
    }
  }

  onSelect(): void {
    this.changed.emit();
  }

  focus(): void {
    this.field.nativeElement.focus();
  }

  select(): void {
    this.field.nativeElement.select();
  }

}
